<template>
    <div class="actionsList">
        <button type="button" class="btn btn-sm btn-secondary actionsList__trigger" @click="open = !open">
            <icon-dots></icon-dots>
        </button>
        <div class="actionsList__menu" v-if="open" @click="open = false">
            <slot></slot>
        </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({})
export default class ActionsList extends Vue {

    open = false;

    mounted() {
        document.addEventListener('click', this.onDocumentClick);
    }

    beforeUnmount() {
        document.removeEventListener('click', this.onDocumentClick);
    }

    onDocumentClick(e: MouseEvent) {
        e.preventDefault();
        e.stopPropagation();
        if (!this.$el.contains(e.target as Node))
            this.open = false;
    }
}
</script>

<style scoped>
.actionsList {
    position: relative;
    display: inline-block;
}

.actionsList__menu {
    position: absolute;
    top: 100%;
    right: 0;
    z-index: 50;
    margin-top: 4px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    background-color: white;
    border: 1px solid rgba(0,0,0,0.15);
    border-radius: 6px;
    padding: 8px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
    min-width: max-content;
}
</style>
